import { ErrorText } from '../common.style';

type ConfirmationWarningsProps = {
  warnings: string[];
};

export const ConfirmationWarnings = ({ warnings }: ConfirmationWarningsProps) => {
  return (
    <>
      {warnings.map((warning) => (
        <ErrorText key={warning} $mb={16}>
          {warning}
        </ErrorText>
      ))}
    </>
  );
};
